import { Message, MsgBox } from 'h_ui/dist/h_ui.min.js'

export function toast (type, message, duration = 2) {
  const cfg = { content: message, duration: duration, closable: true }
  switch (type) {
    case 'warning':
      Message.warning(cfg)
      break
    case 'success':
      Message.success(cfg)
      break
    case 'error':
      Message.error(cfg)
      break
    default:
      Message.info(cfg)
  }
}

export function dialog (type, title, message, okFunc) {
  const cfg = { title: title, content: message, onOk: okFunc }
  switch (type) {
    case 'warning':
      MsgBox.warning(cfg)
      break
    case 'success':
      MsgBox.success(cfg)
      break
    case 'error':
      MsgBox.error(cfg)
      break
    case 'confirm':
      MsgBox.confirm(cfg)
      break
    default:
      MsgBox.info(cfg)
  }
}
